import { AccountBrandingRequest } from 'vopay';
import { useApi } from '#shared/providers/Api';

export default function useFetchAccountBranding() {
  const api = useApi();

  async function fetchAccountBranding(params: AccountBrandingRequest) {
    try {
      const res = await api.fetchAccountBranding(params);

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return { fetchAccountBranding };
}
